import React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';

const HeroSection = styled.section`
  background-color: #FAF9F8;
  padding: 4rem 2rem;
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
`;

const HeroTitle = styled.h1`
  color: #7AA6A2;
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  font-weight: 700;
`;

const ContentSection = styled.section`
  padding: 4rem 2rem;
  max-width: 1000px;
  margin: 0 auto;
`;

const Admins = () => {
    return (
        <Layout
            title="Ministry Admins"
            description="Support and resources for ministry administrators."
            path="/admins"
            noindex
        >
            <HeroSection>
                <HeroTitle>Ministry Admins</HeroTitle>
            </HeroSection>
            <ContentSection>
                <p>
                    Ministry administrators play a vital role in the health and sustainability of the church.
                    We provide coaching, resources, and a community for those serving in administrative roles.
                </p>
            </ContentSection>
        </Layout>
    );
};

export default Admins;
